import styled, { css } from 'styled-components'

export const ProductButton = styled.div`
`

export const BundleItems = styled.div`
  max-height: 175px;
  overflow-y: auto;

  display: grid;
  grid-template-columns: 50px max-content 1fr;

  margin-bottom: 12px !important;

  background:
  /* Shadow covers */
    linear-gradient(white 30%, rgba(255,255,255,0)),
    linear-gradient(rgba(255,255,255,0), white 70%) 0 100%,

    /* Shadows */
    radial-gradient(50% 0, farthest-side, rgba(0,0,0,.2), rgba(0,0,0,0)),
    radial-gradient(50% 100%,farthest-side, rgba(0,0,0,.2), rgba(0,0,0,0)) 0 100%;
  background:
    /* Shadow covers */
    linear-gradient(white 30%, rgba(255,255,255,0)),
    linear-gradient(rgba(255,255,255,0), white 70%) 0 100%,

    /* Shadows */
    radial-gradient(farthest-side at 50% 0, rgba(0,0,0,.15), rgba(0,0,0,0)),
    radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.15), rgba(0,0,0,0)) 0 100%;
  background-repeat: no-repeat;
  background-color: white;
  background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
  background-attachment: local, local, scroll, scroll;
`

export const BundleItemRow = styled.div`
  display: contents;
`

export const BundleItemCell = styled.div`
  display: flex;
  align-items: center;

  padding: 5px !important;

  font-size: 14px !important;

  ${({ disabled }) => disabled && css`
    opacity: 0.6;
  `}

  /* Need to specificity hack here ;< */
  &&&&&&&{
    select.bq-variation {
      font-size: 14px !important;
      margin-bottom: 0 !important;
    }
  }
`
